"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dynamicRef_1 = require("./dynamicRef");
const def = {
    keyword: "$recursiveRef",
    schemaType: "string",
    code: (cxt) => dynamicRef_1.dynamicRef(cxt, cxt.schema),
};
exports.default = def;
//# sourceMappingURL=recursiveRef.js.map